export default __webpack_public_path__ + "static/media/Edit.a2fad36b.svg";